import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Per-category notification preferences. Both popup (in-app toast) and
 * sound (Web Audio beep) default to true so a fresh user gets the full
 * notification experience and can opt out from the toast itself.
 */
export interface NotificationCategoryPrefs {
  popup: boolean
  sound: boolean
}

export type NotificationCategoryKey = 'moderatorApproval' | 'adventureInvite' | 'silentAdventure' | 'journalEntry'

interface NotificationPreferencesState {
  moderatorApproval: NotificationCategoryPrefs
  adventureInvite: NotificationCategoryPrefs
  silentAdventure: NotificationCategoryPrefs
  journalEntry: NotificationCategoryPrefs

  toggleCategoryPopup: (category: NotificationCategoryKey) => void
  toggleCategorySound: (category: NotificationCategoryKey) => void
  setCategoryPrefs: (category: NotificationCategoryKey, prefs: NotificationCategoryPrefs) => void
}

const defaultCategoryPrefs: NotificationCategoryPrefs = { popup: true, sound: true }

export const useNotificationPreferencesStore = create<NotificationPreferencesState>()(
  persist(
    (set) => ({
      moderatorApproval: { ...defaultCategoryPrefs },
      adventureInvite: { ...defaultCategoryPrefs },
      silentAdventure: { ...defaultCategoryPrefs },
      journalEntry: { ...defaultCategoryPrefs },

      toggleCategoryPopup: (category) => set((state) => ({
        [category]: { ...state[category], popup: !state[category].popup },
      })),
      toggleCategorySound: (category) => set((state) => ({
        [category]: { ...state[category], sound: !state[category].sound },
      })),
      setCategoryPrefs: (category, prefs) => set(() => ({
        [category]: prefs,
      })),
    }),
    {
      name: 'adventurecore-notification-prefs',
      version: 2,
    }
  )
)
